import { dateRangeType } from '@/core/models/date-range';
import { quickSelectRangeType } from '@/common/shared/date-range-selector/date-range-selector.component';
import '@/common/shared/arktype.config';
import { type } from 'arktype';

export function getApiNoteFilterValue(noteTextFilter: string, noteCheckFilter: boolean | undefined): boolean | string {
    return noteTextFilter && noteCheckFilter === true
        ? noteTextFilter
        : noteCheckFilter !== undefined
          ? noteCheckFilter
          : ''; // empty string is strange but complies to legacy behavior for "no filter".
}

export const userFilterType = type({
    name: 'string',
    id: 'number',
});
export type UserFilter = typeof userFilterType.infer;

/*
export interface UserFilter {
    name: string;
    id: number;
}
*/

export const layerFilterType = type({
    name: 'string',
    id: 'number',
});
export type LayerFilter = typeof layerFilterType.infer;

/*
export interface LayerFilter {
    name: string;
    id: number;
}
 */

export const teamFilterOptionType = type({
    type: "'members' | 'groups'",
    id: 'number',
    name: 'string',
});
export type TeamFilterOption = typeof teamFilterOptionType.infer;

export type TeamFilterOptionTypes = 'members' | 'groups';
/*
export type TeamFilterOption = {
    type: TeamFilterOptionTypes;
    id: number;
    name: string;
};
*/

export const analyzeFiltersType = type({
    dateRange: dateRangeType,
    dateRangeOption: [quickSelectRangeType, '|', 'undefined'],
    isBilled: 'boolean | undefined',
    isNoteAvailable: 'boolean | undefined',
    selectedLayer1Filter: layerFilterType.array(),
    selectedLayer2Filter: layerFilterType.array(),
    selectedLayer3Filter: layerFilterType.array(),
    filterDescription: 'string',
    selectedTeamFilter: teamFilterOptionType.array().or('null'),
});

export type AnalyzeFilters = typeof analyzeFiltersType.infer;

/*
export type AnalyzeFilters = {
    dateRange: DateRange;
    isBilled: boolean | undefined;
    isNoteAvailable: boolean | undefined;
    selectedLayer1Filter: LayerFilter[];
    selectedLayer2Filter: LayerFilter[];
    selectedLayer3Filter: LayerFilter[];
    filterDescription: string;
    selectedTeamFilter: TeamFilterOption[] | null;
};
*/
